import Vue from "vue";
import App from "./App.vue";
import Router from "./router";
import Store from "./store";

import VueLocalStorage from "vue-ls";
import Vuex from "vuex";
import Vue2Filters from "vue2-filters";

import "bulma/css/bulma.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import GeneralHelper from "./assets/js/helpers/general/install";
import "@/assets/css/custom.css";
import "animate.css/animate.min.css";

Vue.use(Vuex);
Vue.use(VueLocalStorage);
Vue.use(GeneralHelper);
Vue.use(Vue2Filters);

Vue.config.productionTip = false;

new Vue({
  router: Router,
  store: Store,
  render: h => h(App)
}).$mount("#app");
